import React from 'react'
import {CSSTransitionGroup} from 'react-transition-group'
import QuestionScreenPR from './questionScreenPR.js'

export default class PVBody extends React.Component{
	render() {
		const {
			pvData,
			questionID,
			handleReply,
			pvOptionsHash,
			lang,
			setPVAnswer
		} = this.props
		return(
			<div className ="pvBody">
				<CSSTransitionGroup
					transitionName="pv-background"
					transitionAppear={true}
					transitionAppearTimeout={1000}
					transitionEnterTimeout={1000}
					transitionLeaveTimeout={1000}>
					<QuestionScreenPR
						data={pvData}
						screenID={questionID} 
						handler={handleReply}
						key={questionID}
						pvOptionsHash={pvOptionsHash}
						lang={lang}
						setPVAnswer={setPVAnswer}
					/>
				</CSSTransitionGroup>
			</div>
		)
	}
}


// WEBPACK FOOTER //
// ./src/components/presentationReferral/subcomponents/pvBody.js